import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamily } from '../lib/family.jsx';

export default function Onboarding() {
  const { createFamily, family } = useFamily();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  if (family) { navigate('/', { replace: true }); return null; }

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await createFamily(name.trim());
      navigate('/children', { replace: true });
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <main className="app-shell stack">
      <p className="eyebrow">Step one of two</p>
      <h1>Name your crew</h1>
      <p className="muted">Whatever the kids already call you all. It shows up on every screen.</p>
      <form className="card stack" onSubmit={submit}>
        <label>
          Family name
          <input value={name} onChange={(e) => setName(e.target.value)} required maxLength={80} placeholder="The Lawsons" />
        </label>
        {error && <p className="notice error">{error}</p>}
        <button className="primary" type="submit" disabled={busy || !name.trim()}>
          {busy ? 'Creating…' : 'Create'}
        </button>
      </form>
    </main>
  );
}
